import { apiFetch } from '../utils/apiClient';
import { S3_JOBS_QUERY_PATH } from '../constants/apiEndpoints';

export async function fetchJobsBySourceId(sourceId, limit = 50) {
    if (!sourceId) {
        return { jobs: [] };
    }

    const response = await apiFetch(S3_JOBS_QUERY_PATH({ source_id: sourceId, limit }), {
        method: 'GET',
        retry: false
    });

    return {
        jobs: Array.isArray(response?.jobs) ? response.jobs : []
    };
}
